import api from "api";
import { apiHeaderOptions } from "./apiHeaderOptions";

const getAssetDetails = async (id: string) => {
  const url = api.config.getAssetDetails(id);
  const requestOptions = apiHeaderOptions();
  return fetch(url, requestOptions);
};

const getPresignedUrl = async (id: string) => {
  const url = api.config.getSignedUrl(id);
  const requestOptions = apiHeaderOptions();
  return fetch(url, requestOptions);
};

export const assetEditService = {
  getAssetDetails,
  getPresignedUrl
};
